// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"1c29cc90","413":"b5e899fc"}[chunkId] + ".chunk.js";
};